import { render, staticRenderFns } from "./ResultWord.vue?vue&type=template&id=1820ceec&scoped=true"
import script from "./ResultWord.vue?vue&type=script&lang=js"
export * from "./ResultWord.vue?vue&type=script&lang=js"
import style0 from "./ResultWord.vue?vue&type=style&index=0&id=1820ceec&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1820ceec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1820ceec')) {
      api.createRecord('1820ceec', component.options)
    } else {
      api.reload('1820ceec', component.options)
    }
    module.hot.accept("./ResultWord.vue?vue&type=template&id=1820ceec&scoped=true", function () {
      api.rerender('1820ceec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/resultWord/ResultWord.vue"
export default component.exports